
/**
* グローバルに使い回す変数
*/

export default {
    // ウィンドウサイズ
    win_width: 0,
    win_height: 0
};



// WEBPACK FOOTER //
// ./js/module/flower/valiable.js